import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {MatTableDataSource} from "@angular/material/table";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {AuthService} from "../../../shared/services/auth.service";
import {FilterService} from "../../../shared/services/filter.service";
import {ActivatedRoute, Router} from "@angular/router";
import {select, Store} from "@ngrx/store";
import {StoreRootState} from "../../../shared/ngrx/reducers";
import {CompetitionImportService} from "../../../shared/services/competition-import.service";
import {delay, distinctUntilChanged, takeUntil, tap} from "rxjs/operators";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {getCurrentRouteState} from "../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../shared/ngrx/route-serializer";
import {CompetitionImport} from "../../../shared/interface/competition-import";
import {NgForm} from "@angular/forms";
import {IMPORT_STATUS_IN_PROGRESS} from "../../../shared/services/dict.service";
import {CompetitionImportRow} from "../../../shared/interface/competition-import-row";

@Component({
  selector: 'app-competition-import-row-list',
  templateUrl: './competition-import-row-list.component.html',
  styleUrls: ['./competition-import-row-list.component.scss']
})
export class CompetitionImportRowListComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('filtersForm') filtersForm: NgForm;

  participantsDataSource: MatTableDataSource<CompetitionImportRow> = new MatTableDataSource<CompetitionImportRow>([]);

  initialFilters: any;
  displayedColumns: string[] = [
    'ofwca',
    'partner',
    'assetsRegional',
    'award',
    'amount',
    'additional',
  ];

  competitionId?: string = null;
  sortBy = null;
  sortOrder = null;
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;
  imports: CompetitionImport[] = [];
  readonly IMPORT_STATUS_IN_PROGRESS = IMPORT_STATUS_IN_PROGRESS;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private route: ActivatedRoute,
    private competitionImportService: CompetitionImportService,
    private auth: AuthService,
    private filterService: FilterService,
    private activatedRoute: ActivatedRoute,
    private store: Store<StoreRootState>,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();

    this.competitionImportService.importRowsListSubject
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<CompetitionImportRow>) => {
          this.participantsDataSource.data = e?.items ?? [];
          this.totalData = e?.pagination?.total ?? this.participantsDataSource.data.length;
        })
      )
      .subscribe();

    this.parseFilters();
  }

  ngOnInit(): void {
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
    }, filters);
  }

  ngAfterViewInit(): void {
    this.participantsDataSource.paginator = this.paginator;

    this.paginator.page
      .pipe(takeUntil(this.destroyed$))
      .subscribe((event: PageEvent) => {
        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: {
            page: event.pageIndex,
            pageSize: event.pageSize,
          },
        });
      });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.parseFilters(state.queryParams);

        this.competitionId = state.params?.id ?? this.route.snapshot.params?.id;

        if (this.paginator && this.competitionId) {
          this.paginator.pageIndex = state.queryParams.page || 0;
          this.paginator.pageSize = state.queryParams.pageSize || 10;
          this.loadListData();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadListData(): void {
    this.competitionImportService.getCompetitionImportRows(
      this.competitionId,
      this.paginator.pageIndex,
      this.paginator.pageSize,
      this.initialFilters
    );
  }

  filter(): void {
    const formValues = { ...this.filtersForm?.value };

    for (const key in formValues) {
      if (formValues[key] === undefined || formValues[key] === null || formValues[key] === '') {
        delete formValues[key];
      }
    }

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        page: 0,
        pageSize: this.paginator?.pageSize || 10,
        ...formValues
      },
    });
  }

  resetFilters(): void {
    this.filtersForm?.resetForm();

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        page: 0,
        pageSize: this.paginator?.pageSize || 10,
      },
    });
  }
}
